{
  "alerts": {
    "edit": "Edit Alert",
    "new": "Create Alert",
    "navigation_title": "Alerts",
    "alert_info": "Alert Info",
    "go_to_index": "Back to Alerts",
    "title": "Alerts",
    "config_page_title": "Edit Alert",
    "monitor_page_title": "Monitor Alert",
    "config_page_breadcrumb": "Edit",
    "monitor_page_breadcrumb": "Monitor",
    "create_new": "Create New",
    "create_simple_alert": "Alert",
    "create_group_alert": "Group Alert",
    "create_new_group_alert": "Create New Group Alert",
    "open_monitor": "Events",
    "edit_configuration": "Configuration",
    "create_configuration": "Create Configuration",
    "triggered_never": "Never",
    "subscribers": "Subscribers",
    "event_graph": "Event Graph",
    "manage_alerts": "Manage Alerts",
    "create_condition": "+ Add Condition",
    "conditions_type_help_text": "* Please select type between conditions",
    "conditions_type_help_tooltip": "Alert will trigger in case of :\n<ul id='tooltip_conditions'>\n<li><b>AND</b> if all conditions are true</li>\n<li><b>OR</b> if any condition is true</li>\n</ul>",
    "events": {
      "empty_nodes": "No accessible nodes for this alert",
      "duration_hm_tooltip": "%{date}<br />%{duration}",
      "duration_hm_day_tooltip": "%{date}<br />24 hours",
      "triggered_hm": "alert state change",
      "triggered_hm_plural": "alert state changes",
      "download_csv": "Download",
      "showing": "Showing",
      "prev_month": "Previous month",
      "next_month": "Next month",
      "reset_date_selection": "Reset date selection"
    },
    "manage_actions": {
      "delete": "Delete",
      "delete_past": "deleted",
      "activate": "Activate",
      "activate_past": "activated",
      "deactivate": "Deactivate",
      "deactivate_past": "deactivated"
    },
    "manage_dialog": {
      "success": "Alerts have been %{action} successfuly",
      "error": "Error occurred, try again later or contact Netronix support"
    },
    "statuses": {
      "deactivated": "Deactivated",
      "resolved": "Resolved",
      "active": "Active",
      "idle": "Idle"
    },
    "durations": {
      "empty_list": "No alert state changes",
      "total": "Total Duration",
      "triggered": "Triggered",
      "duration": "Duration"
    },
    "select_nodes": "Select Node",
    "select_subscriptions": "Select Subscriber",
    "empty_subscribers": "None",
    "select_sensor": "Select Sensor",
    "select_param": "Select Parameter",
    "select_timerange": "Select Period",
    "select_func": "Select Comparator",
    "nodes_help_text": "Conditions below are applied on each node independently",
    "activation_period": "Activation Period",
    "message_help_text_remaining": "Remaining characters:",
    "notification_method_titles": {
      "email_sms": "SMS and Email will be sent when alert is triggered",
      "sms": "SMS will be sent when alert is triggered",
      "email": "Email will be sent when alert is triggered"
    },
    "notification_methods": {
      "email_sms": "Email & SMS",
      "sms": "SMS",
      "email": "Email"
    },
    "tooltips": {
      "deactivation_ts": "Deactivation date - when this Alert will become inactive and stop monitoring",
      "activation_ts": "Activation date - when this Alert will become active and start monitoring",
      "reactivation_time_ms": "Delay between two consecutive notifications",
      "notification_level": "Based on this selection and user private notification level user will get notification when alert is triggered"
    },
    "rules": "Conditions",
    "ref": "Reference",
    "refs": "References",
    "empty_rules": "No Conditions",
    "empty_nodes": "No Nodes",
    "empty_subscriptions": "No Subscribers",
    "empty_comparator": "Choose comparator",
    "controls": {
      "share": "Share",
      "activate": "Activate",
      "deactivate": "Deactivate"
    },
    "validation": {
      "nodes": "at least one node should be added",
      "conditions": "at least one condition should be added",
      "subscriptions": "at least one subscriber should be added",
      "references_not_used": "References that are not used in any condition will be removed",
      "some_editing": "There are rows under edition. Saving is not possible until they are not finished"
    },
    "success": {
      "deleted": "Alert was successfully deleted"
    },
    "errors": {
      "not_found": "Alert is not valid",
      "no_action": "No such alert action %{type}",
      "unknown_notification": "Unknown notification method"
    },
    "states": {
      "idle": "Idle",
      "resolved": "Resolved",
      "active": "Active",
      "deactivated": "Deactivated",
      "activated": "Activated"
    },
    "references": {
      "add_new_plus": "+ Add Reference",
      "add_new": "Add Reference"
    },
    "monitor": {
      "basic_info": {
        "name": "Name",
        "owner": "Owner",
        "message": "Message",
        "notification_type": "Notification Type"
      },
      "actions": {
        "chart": "Chart",
        "table_data": "Table Data"
      },
      "range": {
        "keep_time_range": "Keep time range across alerts"
      },
      "table": {
        "duration": "Duration",
        "state_changes": "State Changes",
        "total_duration": "Total Duration",
        "total_state_changes": "Total State Changes",
        "condition_status": {
          "poor": "Poor",
          "good": "Good"
        }
      }
    }
  },
  "conditions": {
    "expressions": {
      "eq": "=",
      "neq": "≠",
      "lt": "<",
      "lte": "≤",
      "gt": ">",
      "gte": "≥",
      "eq_title": "equal to",
      "neq_title": "not equal to",
      "lt_title": "less than",
      "lte_title": "less or equal to",
      "gt_title": "greater than",
      "gte_title": "greater or equal to",
      "abs": "Abs",
      "abs_title": "Abs",
      "min": "Min",
      "min_title": "Minimum",
      "max": "Max",
      "max_title": "Maximum",
      "avg": "Avg",
      "avg_title": "Average",
      "diff": "Diff",
      "diff_title": "Difference",
      "sum": "Sum",
      "sum_titlte": "Sum",
      "scale": "Scale",
      "scale_titlte": "Scale",
      "link": "Linked",
      "link_title": "Linked"
    },
    "add_condition": "Add Condition",
    "conditions_or": "Add Condition (OR)",
    "add_condition_or": "Add Condition (AND)",
    "no_conditions": "No conditions"
  }
}